import axios from 'axios';
import { getAuthTokens, setAuthToken, clearAuthToken } from '../utils/auth';
import { isTokenExpired } from '../utils/IsTokenExpired';
import { getCiraServiceEndpoint } from '../config/runtimeConfig';

const api = axios.create({
  baseURL: getCiraServiceEndpoint(),
});

api.interceptors.request.use(
  async (config) => {
    const { authToken, refreshToken } = getAuthTokens();
    config.headers.Authorization = `Bearer ${authToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
